import { selectUseFilteredTracking } from 'core/userContext';
import { useSelector } from 'react-redux';
import { SideNav } from 'ui/sideNav';
import { sideNavLinks } from '../constants';
import { ProjectSettingsFormProvider, useProjectSettingsQueryContext } from '../contexts';
import { ProjectSettingsModals } from './modals';
import { ProjectSettingsForm } from './ProjectSettingsForm';
import { Content, ContentContainer } from './ProjectSettingsPage.styled';
import { ProjectSettingsPageHeader } from './ProjectSettingsPageHeader';
import { useScrollIntoView } from 'utils/hooks/useScrollIntoView';
import { useWhatsAppMessageChannelFeature } from 'utils/hooks/featureFlags';

export const DISPLAY_TEXT = {
  PAGE_HEADER: 'Settings',
  SAVE_BUTTON: 'Save',
};

const withProjectSettingsPageContext =
  <ProjectSettingsPageConsumerProps extends Record<string | number, unknown>>(
    ProjectSettingsPageConsumer: React.FC<ProjectSettingsPageConsumerProps>,
  ) =>
  (props: ProjectSettingsPageConsumerProps) => {
    const { project, labels } = useProjectSettingsQueryContext();

    if (!Object.entries(project).length) return null;

    return (
      <ProjectSettingsFormProvider project={project} labels={labels}>
        <ProjectSettingsPageConsumer {...props} />
        <ProjectSettingsModals />
      </ProjectSettingsFormProvider>
    );
  };

export const ProjectSettingsPage = withProjectSettingsPageContext(() => {
  const { hasSmsChannel } = useProjectSettingsQueryContext();
  const useFilteredTracking = useSelector(selectUseFilteredTracking);
  const { isWhatsAppEnabled } = useWhatsAppMessageChannelFeature();

  // enables SideNav to scroll to section of page with `hash` link
  useScrollIntoView();

  return (
    <>
      <ProjectSettingsPageHeader />

      <ContentContainer>
        <Content>
          <SideNav
            isSticky
            linksAndSections={[
              {
                header: 'Settings',
                links: sideNavLinks({ hasSmsChannel, useFilteredTracking, isWhatsAppEnabled }),
              },
            ]}
            stickyPadding={80}
          />
          <ProjectSettingsForm />
        </Content>
      </ContentContainer>
    </>
  );
});
